import { render } from "./CompetitionJudgeAssignmentPanel.vue?vue&type=template&id=2ed53cca&scoped=true"
import script from "./CompetitionJudgeAssignmentPanel.vue?vue&type=script&lang=js"
export * from "./CompetitionJudgeAssignmentPanel.vue?vue&type=script&lang=js"

import "./CompetitionJudgeAssignmentPanel.vue?vue&type=style&index=0&id=2ed53cca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed53cca"]])

export default __exports__